/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ModerationActionBanContainer_settings = {
    readonly multisite: boolean;
    readonly " $refType": "ModerationActionBanContainer_settings";
};
export type ModerationActionBanContainer_settings$data = ModerationActionBanContainer_settings;
export type ModerationActionBanContainer_settings$key = {
    readonly " $data"?: ModerationActionBanContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"ModerationActionBanContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ModerationActionBanContainer_settings",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "multisite",
            "storageKey": null
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = '7498bf25180e732e68cf8d786851443e';
export default node;
